// extracted by mini-css-extract-plugin
export default {"card":"CardRecipe_card__FkFIs","image":"CardRecipe_image__wYJ-P","name":"CardRecipe_name__5I2W8","ico":"CardRecipe_ico__894ob"};